(function($){

    // Make Depth 1 Links not clickable
	$('.sub-menu .depth-1 > a span').unwrap();


})(jQuery);
